import React from "react";
import { useNode, useEditor } from "@craftjs/core";
import { useDrop } from "react-dnd";

const EmptyAccordionContainer = ({ children }) => {
  const {
    connectors: { connect },
    nodeId,
    actions: { addNode },
    hasChildren,
  } = useNode((node) => {
    return {
      hasChildren: node.data.nodes.length > 0,
    };
  });

  const { query } = useEditor();

  const [{ isOver }, drop] = useDrop({
    accept: "TOOL",
    drop: (item, monitor) => {
      const newNode = query.createNode(item.tool);
      addNode(newNode, nodeId);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div ref={(ref) => connect(drop(ref))} style={{ padding: "10px" }}>
      {hasChildren ? (
        children
      ) : (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#F5F5F5",
            padding: "20px",
            border: isOver ? "2px dashed #4CAF50" : "1px dashed #ccc",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#0058B8",
            }}
          >
            This Accordion is empty <br />
            <span
              style={{
                fontSize: "14px",
                color: "#565556",
              }}
            >
              Drag a <b>block</b> to add Content
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

export default EmptyAccordionContainer;
